const {bind} = require('./lib/bind')
const niceBytes = require('./lib/nice-bytes')

document.addEventListener("DOMContentLoaded",function(){
  if(!document.getElementById('user_avatar')) return
  var notice = document.getElementById('avatar-notice')
  var max_file_size = 1500000
  var submit = ''
  bind(document.getElementById('user_avatar'), 'change', function() {
    var filename = this.files[0].name
    var filesize = this.files[0].size
    if(filesize > max_file_size){
      notice.classList.toggle('alert-warning')
      document.getElementById('user_avatar').value = ''
      submit = '<strong>Too large</strong>'
    } else {
      notice.classList.toggle('alert-primary')
      submit = '<button type="submit" class="btn btn-sm btn-light">Upload</button>'
    }
    notice.innerHTML = `<div>Avatar: ${filename} (${niceBytes(filesize)})</div> ${submit}`
  })
})
